var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContainerSimbols',{staticClass:"fill-height",attrs:{"color":"secondary-variant"}})
}
var staticRenderFns = []

export { render, staticRenderFns }